import { Routes } from '@angular/router';
import { calGuard } from './auth/cal.guard';
import { roleGuard } from './auth/role.guard';
import { ActivePlanGuard } from './auth/active-plan.guard';
import { selectedRegionGuard } from './auth/selected-region.guard';
import { planEditorUnsavedChangesGuard } from './auth/plan-editor-unsaved-changes.guard';
import { unsavedChangesGuard } from './auth/unsaved-changes.guard';
// import { StartPageComponent } from './components/start-page/start-page.component';

export const routes: Routes = [
  {
    path: "",
    loadComponent: () => import('./components/menu-layout/menu-layout.component').then(m => m.MenuLayoutComponent),
    children: [
      {
        path: "",
        redirectTo: "model",
        pathMatch: "full"
      },
      {
        path: "model",
        loadComponent: () => import('./components/model/model.component').then(m => m.ModelComponent)
      },
      {
        path: "model/petro-mappings",
        loadComponent: () => import('./components/model_explorer_models/petro-mappings/petro-mappings.component').then(m => m.PetroMappingsComponent)
      },
      {
        path: "model/trade-categories",
        loadComponent: () => import('./components/model_explorer_models/trade-categories/trade-categories.component').then(m => m.TradeCategoriesComponent)
      },
      {
        path: "model/elements",
        loadComponent: () => import('./components/model_explorer_models/elements/elements.component').then(m => m.ElementsComponent),
        canActivate: [selectedRegionGuard]
      },
      {
        path: "model/feed-inventory-limits",
        loadComponent: () => import('./components/model_explorer_models/feed-inventory-limits/feed-inventory-limits.component').then(m => m.FeedInventoryLimitsComponent),
        canActivate: [selectedRegionGuard]
      },
      {
        path: "model/terminal-recipes",
        loadComponent: () => import('./components/model_explorer_models/terminal-recipes/terminal-recipes.component').then(m => m.TerminalRecipesComponent),
        canActivate: [selectedRegionGuard]
      },
      {
        path: "model/settings",
        loadComponent: () => import('./components/model_explorer_models/settings/settings.component').then(m => m.SettingsComponent),
        canActivate: [selectedRegionGuard]
      },
      {
        path: "model/locations",
        loadComponent: () => import('./components/model_explorer_models/locations/locations.component').then(m => m.LocationsComponent),
        canActivate: [selectedRegionGuard]
      },
      {
        path: "model/materials",
        loadComponent: () => import('./components/model_explorer_models/Materials/materials/materials.component').then(m => m.MaterialsComponent),
        canActivate: [selectedRegionGuard]
      },
      {
        path: "model/partners",
        loadComponent: () => import('./components/model_explorer_models/Partners/partners/partners.component').then(m => m.PartnersComponent),
        canActivate: [selectedRegionGuard]
      },
      {
        path: "model/rules-configuration",
        loadComponent: () => import('./components/model_explorer_models/rules-configuration/rules-configuration//rules-configuration.component').then(m => m.RulesConfigurationComponent),
        canActivate: [selectedRegionGuard],
        canDeactivate: [unsavedChangesGuard]
      },
      {
        path: "model/movement-generation",
        loadComponent: () => import('./components/model_explorer_models/movement-generation-rules/movement-generation-rules/movement-generation-rules.component').then(m => m.MovementGenerationRulesComponent),
        canActivate: [selectedRegionGuard]
      },
      {
        path: "planning-workspace-home",
        loadComponent: () => import('./components/planning-workspace-home/planning-workspace-home.component').then(m => m.PlanningWorkspaceHomeComponent),
        canActivate: [selectedRegionGuard]
      },
      {
        path: "plan-manager",
        loadComponent: () => import('./components/plan-manager/plan-manager.component').then(m => m.PlanManagerComponent),
        canActivate: [selectedRegionGuard]
      },
      {
        path: "plan-manager-new-plan",
        loadComponent: () => import('./components/plan-manager-new-plan/plan-manager-new-plan.component').then(m => m.PlanManagerNewPlanComponent),
        canActivate: [selectedRegionGuard]
      },
      {
        path: "program-options",
        loadComponent: () => import('./components/tools/program-options/program-options.component').then(m => m.ProgramOptionsComponent),
        canActivate: [selectedRegionGuard]
      },
      {
        path: "app-help",
        loadChildren: () => import('./components/helps/helps.routes').then(m => m.helpRoutes)
      },
      {
        path: "synthesis-case-manager",
        loadComponent: () => import('./components/integrations/synthesis-case-manager/synthesis-case-manager.component').then(m => m.SynthesisCaseManagerComponent),
        canActivate: [ActivePlanGuard],
        canDeactivate: [planEditorUnsavedChangesGuard]

      },
      {
        path: "lp-price-swap-configuation",
        loadComponent: () => import('./components/integrations/lp-price-swap-configuation/lp-price-swap-configuation.component').then(m => m.LpPriceSwapConfiguationComponent),
        canActivate: [ActivePlanGuard, selectedRegionGuard]

      },
      {
        path: "integration/publish-plan",
        loadComponent: () => import('./components/integrations/publish-plan/publish-plan.component').then(m => m.PublishPlanComponent),
        canActivate: [selectedRegionGuard]
      },
      {
        path: 'integration/integration-depot-planning-workspace',
        loadComponent: () => import('./components/integrations/integration-depot-planning-workspace/integration-depot-planning-workspace.component').then(m => m.IntegrationDepotPlanningWorkspaceComponent),
      },
      {
        path: "plan-report",
        loadComponent: () => import('./components/reports/plan-report/plan-report/plan-report.component').then(m => m.PlanReportComponent),
        canActivate: [ActivePlanGuard, selectedRegionGuard]
      },
      {
        path: "report/plan-report",
        redirectTo: "plan-report",
        pathMatch: "full"
      },
      {
        path: "plan-editor",
        loadComponent: () => import('./components/reports/plan-editor/plan-editor-home/plan-editor-home.component').then(m => m.PlanEditorHomeComponent),
        canActivate: [ActivePlanGuard, selectedRegionGuard],
        canDeactivate: [planEditorUnsavedChangesGuard]
      },
      {
        path: "custom-plan-report",
        loadComponent: () => import('./components/reports/custom-report/custom-report.component').then(m => m.CustomReportComponent),
        canActivate: [ActivePlanGuard, selectedRegionGuard]
      },
      {
        path: "supply-demand-balance-report",
        loadComponent: () => import('./components/reports/supply-demand-balance-report/supply-demand-balance-report.component').then(m => m.SupplyDemandBalanceReportComponent),
        canActivate: [ActivePlanGuard, selectedRegionGuard]
      },
      {
        path: "report/supply-demand-balance",
        redirectTo: "supply-demand-balance-report",
        pathMatch: "full",
      },
      {
        path: "report/gross-margin-report/refinery-gross-margin-report",
        loadComponent: () => import('./components/reports/gross-margin-report/gross-margin-report.component').then(m => m.GrossMarginReportComponent),
        canActivate: [ActivePlanGuard, selectedRegionGuard]
      },    
      {
        path: "inventory/inventory-projection",
        loadComponent: () => import('./components/inventories/inventory-projection/inventory-projection.component').then(m => m.InventoryProjectionComponent),
        canActivate: [ActivePlanGuard, selectedRegionGuard],
        canDeactivate: [unsavedChangesGuard]
      },
      {
        path: "inventory/inventory-chart",
        loadComponent: () => import('./components/inventory/inventory-chart/inventory-chart.component').then(m => m.InventoryChartComponent),
        canActivate: [ActivePlanGuard, selectedRegionGuard]
      },
      {
        path: "inventories/baseline-inventory",
        loadComponent: () => import('./components/inventories/baseline-inventory/baseline-inventory.component').then(m => m.BaselineInventoryComponent),
        canActivate: [ActivePlanGuard, selectedRegionGuard]
      },
      {
        path: "report/execute-generate-movement",
        loadComponent: () => import('./components/reports/generate-movement/generate-movement.component').then(m => m.GenerateMovementComponent),
        canActivate: [ActivePlanGuard, selectedRegionGuard]
      },
      {
        path: "report/movement-generation-log",
        loadComponent: () => import('./components/reports/movement-generation-log/movement-generation-log.component').then(m => m.MovementGenerationLogComponent),
        canActivate: [ActivePlanGuard, selectedRegionGuard]
      },
      {
        path: "custom-report",
        loadComponent: () => import('./components/configurations/custom-report/custom-report.component').then(m => m.CustomReportComponent),
        canActivate: [selectedRegionGuard],
        canDeactivate: [unsavedChangesGuard]
      },
      {
        path: 'report/user-activity-report',
        loadComponent: () =>
          import('./components/reports/user-activity-report/user-activity-report.component')
            .then(m => m.UserActivityReportComponent),
      },
      {
        path: 'report/change-time-horizon',
        loadComponent: () =>
          import('./components/reports/change-time-horizon/change-time-horizon.component').then(
            (m) => m.ChangeTimeHorizonComponent,
          ),
        // canActivate: [ActivePlanGuard, selectedRegionGuard],
      },
      {
        path: 'report/comparison-report',
        loadComponent: () =>
          import('./components/reports/comparison-report/comparison-report.component').then(
            (m) => m.ComparisonReportComponent,
          ),
        // canActivate: [ActivePlanGuard, selectedRegionGuard],
      },
      {
        path: 'report/comments',
        loadComponent: () =>
          import('./components/reports/comments/comments.component').then(
            (m) => m.CommentsComponent,
          ),
        canActivate: [ActivePlanGuard, selectedRegionGuard],
        },
        {
            path: 'documents/model-documents',
            loadComponent: () => import('./components/documents/documents.component').then(m => m.DocumentsComponent),
            data: { scope: 'model' },
            canActivate: [selectedRegionGuard]
        },
        {
        path: 'report/distribution-cost-report',
        loadComponent: () =>
          import('./components/reports/distribution-cost-report/distribution-cost-report.component').then(
            (m) => m.DistributionCostReportComponent,
          ),
        canActivate: [ActivePlanGuard, selectedRegionGuard],
        },
    ]
  }
];
